export const GET_COUNTRIES = "GET_COUNTRIES";
export const FILTER_CONTINENT = "FILTER_CONTINENT";
export const ORDER_BY_NAME = "ORDER_BY_NAME";
export const FILTER_BY_POPULATION = "FILTER_BY_POPULATION";
export const GET_NAME_COUNTRIES = "GET_NAME_COUNTRIES";
export const GET_ACTIVITIES = "GET_ACTIVITIES";
export const POST_ACTIVITY = "POST_ACTIVITY";
export const GET_DETAIL = "GET_DETAIL";
export const FILTER_BY_ACTIVITY = "FILTER_BY_ACTIVITY";